import $ from "jquery";
$(document).on('turbolinks:load', () => {
  $(".searchable-select").select2({
    placeholder: "Please Select",
    allowClear: true,
    theme: "bootstrap",
  });

  $('.searchable-select-user').select2({
    placeholder: "Please Select",
    allowClear: true,
    ajax: {
      url: Routes.admin_users_path(),
      data: function(params) {
        var query = {
          q: {phone_cont: params.term, full_name_cont: params.term, m: 'or'},
          page: params.page || 1,
        };
        return query;
      },
      dataType: 'json',
    },
  });

  $('.searchable-select-pet').select2({
    placeholder: "Please Select",
    allowClear: true,
    ajax: {
      url: Routes.admin_pets_path(),
      data: function(params) {
        var query = {
          q: {patient_id_cont: params.term, name_cont: params.term, m: 'or'},
          page: params.page || 1,
        };
        return query;
      },
      dataType: 'json',
    },
  });

  $('.searchable-select-employee').select2({
    placeholder: "Please Select",
    allowClear: true,
    ajax: {
      url: Routes.admin_employees_path(),
      data: function(params) {
        var query = {
          q: {email_cont: params.term, full_name_cont: params.term, m: 'or'},
          page: params.page || 1,
        };
        return query;
      },
      dataType: 'json',
    },
  });
  $('.searchable-select-wallet').select2({
    placeholder: "Please Select",
    allowClear: true,
    ajax: {
      url: Routes.search_admin_wallets_path(),
      data: function(params) {
        var query = {
          q: {phone_cont: params.term, name_cont: params.term, m: 'or'},
          page: params.page || 1,
        };
        return query;
      },
      dataType: 'json',
    },
  });
});
